var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin || _vm.checkAccess('sites'))?_c('div',[_c('report-list-page',{attrs:{"page-title":"Site Report","page-icon":"business","descending":true,"headers":_vm.headers,"state-end-point":"salesCounter.salesCounters","actions":_vm.actions,"show-component":_vm.showComponent,"item-key":"detailId"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }